<template>
    <el-dialog
        class="edit"
        :visible.sync="editVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="编辑活动"
    >
        <div class="container">
            <el-form
                ref="editForm"
                :rules="rules"
                :model="editForm"
                label-width="110px"
            >
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label="活动名称"
                            size="small"
                            prop="title"
                        >
                            <el-input
                                clearable
                                placeholder="请输入活动名称"
                                maxlength="30"
                                size="small"
                                v-model="editForm.title"
                                :readonly="special"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="活动地点"
                            size="small"
                            prop="address"
                        >
                            <el-input
                                clearable
                                placeholder="请输入活动地点"
                                maxlength="30"
                                size="small"
                                v-model.number="editForm.address"
                                :readonly="special"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label="联系人"
                            size="small"
                            prop="contact_name"
                        >
                            <el-input
                                clearable
                                placeholder="请输入联系人"
                                maxlength="30"
                                size="small"
                                v-model="editForm.contact_name"
                                :readonly="special"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="联系电话"
                            size="small"
                            prop="contact_phone"
                        >
                            <el-input
                                clearable
                                placeholder="请输入联系电话"
                                maxlength="30"
                                size="small"
                                v-model.number="editForm.contact_phone"
                                :readonly="special"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label="活动起始时间"
                            size="small"
                            prop="time"
                        >
                            <el-date-picker
                                v-model="editForm.time"
                                type="datetimerange"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                format="yyyy-MM-dd HH:mm:ss"
                                :picker-options="pickerOptions"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="主办方"
                            size="small"
                            prop="sponsor"
                        >
                            <el-input
                                clearable
                                placeholder="请输入主办方"
                                maxlength="30"
                                size="small"
                                v-model="editForm.sponsor"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="12">
                        <el-form-item
                            label="活动结束时间"
                            size="small"
                            prop="end_time"
                        >
                            <el-date-picker
                                v-model="editForm.end_time"
                                type="datetime"
                                placeholder="选择结束时间"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                format="yyyy-MM-dd HH:mm:ss"
                                default-time="00:00:00"
                                :picker-options="pickerOptions"
                                :readonly="special"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col> -->
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label="活动封面"
                            size="small"
                            prop="cover"
                        >
                            <imgUpload2
                                :width="'120'"
                                :height="'120'"
                                :limit="1"
                                :multiple="false"
                                :images="imgList"
                                name="img"
                                :paramData="{ id: tableItem.id }"
                                @imagesChange="imagesChange"
                                :disabled="special"
                            >
                                <p class="words">
                                    *仅支持jpg、png格式的图片上传，且文件大小不大于1M
                                </p>
                            </imgUpload2>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24" v-if="special">
                        <el-form-item
                            label="回顾内容"
                            size="small"
                            prop="content"
                            :rules="[
                                {
                                    required: true,
                                    message: '请输入回顾内容',
                                },
                            ]"
                        >
                            <vue-tinymce
                                v-if="editVisible"
                                v-model="editForm.content"
                                :setting="setting"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-else>
                        <el-form-item
                            label="活动内容"
                            size="small"
                            prop="content"
                        >
                            <vue-tinymce
                                v-if="editVisible"
                                v-model="editForm.content"
                                :setting="setting"
                                :setup="setup"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >保存</el-button
            >
            <el-button size="small" @click="editVisible = false"
                >关闭</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import * as api from "@/http/api.js";
import * as oaApi from "@/http/oaApi.js";
import * as publicApi from "@/http/publicApi.js";
import { mapState } from "vuex";
export default {
    data() {
        return {
            editForm: {
                title: "",
                address: "",
                content: "",
                sponsor: "",
                contact_name: "",
                contact_phone: "",
                time: [],
                start_time: "",
                end_time: "",
                cover: "",
                action: "",
            },
            imgList: [],
            rules: {
                title: [
                    {
                        required: true,
                        message: "请输入活动名称",
                        trigger: "blur",
                    },
                ],
                address: [
                    {
                        required: true,
                        message: "请输入活动地点",
                        trigger: "blur",
                    },
                ],
                content: [
                    {
                        required: true,
                        message: "请输入活动内容",
                        trigger: "blur",
                    },
                ],
                sponsor: [
                    {
                        required: true,
                        message: "请输入主办方",
                        trigger: "blur",
                    },
                ],
                contact_name: [
                    {
                        required: true,
                        message: "请输入联系人",
                        trigger: "blur",
                    },
                ],
                contact_phone: [
                    {
                        required: true,
                        message: "请输入联系电话",
                        trigger: "blur",
                    },
                    {
                        pattern: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
                        message: "手机号格式有误",
                    },
                ],
                time: [
                    {
                        required: true,
                        message: "请选择活动起始时间",
                        trigger: "blur",
                    },
                ],
                cover: [
                    {
                        required: true,
                        message: "请选择活动封面",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    components: {
        imgUpload2: () => import("@/comon/components/imgUpload2.vue"),
    },
    props: {
        editVisible: Boolean,
        tableItem: Object,
        special: Boolean,
    },
    watch: {
        editVisible: {
            handler(newValue) {
                if (newValue) {
                    this.activityList();
                }
            },
        },
    },
    computed: {
        ...mapState({
            setting: (state) => state.index.setting,
            pickerOptions: (state) => state.index.pickerOptions,
        }),
    },
    methods: {
        /**
         * 保存
         */
        save() {
            this.$refs["editForm"].validate((valid) => {
                if (valid) {
                    // 编辑
                    if (!this.special) {
                        this.editForm.start_time = this.editForm.time[0];
                        this.editForm.end_time = this.editForm.time[1];
                        oaApi
                            .activityList(
                                this.editForm,
                                "put",
                                this.tableItem.id
                            )
                            .then((res) => {
                                if (res.code == 200) {
                                    //console.log(res);
                                    this.$parent.activityList();
                                    this.closeDialog();
                                    this.$message.success("编辑成功!");
                                }
                            });
                    }
                    // 回顾
                    else {
                        oaApi
                            .eventsReview(
                                {
                                    event_id: this.tableItem.id,
                                    content: this.editForm.content,
                                },
                                "post"
                            )
                            .then((res) => {
                                if (res.code == 200) {
                                    //console.log(res);
                                    this.$emit("update:editVisible", false);
                                    this.$message.success("编辑成功!");
                                }
                            });
                    }
                }
            });
        },
        /**
         * 关闭对话框
         */
        closeDialog() {
            this.$emit("update:editVisible", false);
            this.$refs["editForm"].resetFields();
            this.$refs["editForm"].clearValidate();
        },
        /**
         * 图片上传组件,上传之后的回调
         */
        imagesChange(imgList) {
            //console.log(imgList);
            let arr = [];
            imgList.map((item) => {
                arr.push(item);
            });
            //console.log(arr.toString());
            this.editForm.cover = arr.toString();
            // 去除相应的必填提示语
            this.$refs["editForm"].clearValidate("cover");
        },
        /**
         * 富文本失去焦点
         */
        setup(editor) {
            editor.on("blur", (e) => {
                this.$refs["editForm"].clearValidate("content");
            });
            editor.on("KeyDown", e => {
                if ((e.keyCode == 8 || e.keyCode == 46) && editor.selection) {
                    // delete & backspace keys
                    var selectedNode = editor.selection.getNode(); // get the selected node (element) in the editor
                    if (selectedNode && selectedNode.nodeName == "IMG") {
                        publicApi
                            .delFile(
                                {
                                    image_url: selectedNode.src
                                },
                                "post"
                            )
                            .then(res => {
                                if (res.code == 200) {
                                }
                            })
                            .catch(err => {
                                return false;
                            });
                    }
                }
            });
        },
        /**
         * 获取单个活动详情
         */
        activityList() {
            oaApi.activityList({}, "get", this.tableItem.id).then((res) => {
                if (res.code == 200) {
                    for (let key in res.data) {
                        this.editForm[key] = res.data[key];
                    }
                    this.$set(this.editForm, "time", [
                        res.data.start_time,
                        res.data.end_time,
                    ]);
                    if (this.special) {
                        this.editForm.content = "";
                        oaApi
                            .eventsReview(
                                {
                                    event_id: this.tableItem.id,
                                },
                                "get"
                            )
                            .then((res) => {
                                if (res.code == 200) {
                                    //console.log(res);
                                    this.editForm.content = res.data.review;
                                }
                            });
                    }
                    //console.log(this.editForm);
                    if (this.editForm.cover != "")
                        this.imgList = this.editForm.cover.split(",");
                    //console.log(this.imgList);
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.edit {
    .el-dialog__body {
        padding: 20px 40px;
    }
    .el-select,
    .el-date-editor {
        width: 100%;
    }
    .el-form-item {
        .el-form-item__content {
            .el-radio {
                margin: 0;
                width: 100px;
            }
        }
    }
    .container {
        margin-top: 10px;
        .seccussImg {
            width: 80px;
            margin-top: 18px;
        }
        .seccussText {
            font-size: 18px;
            font-weight: bold;
            line-height: 2;
            margin-top: 18px;
        }
        .tableSchool,
        .tableHealth {
            .el-form-item--small.el-form-item {
                margin-bottom: 0;
            }
        }
    }
}
</style>